import axios from "./axiosInstance";
import {
  Leave,
  LeaveCreate,
  LeaveUpdate,
  LeaveApiResponse,
  LeaveCreateApiResponse,
  LeaveUpdateApiResponse,
  LeaveListApiResponse,
} from "../types/leaveTypes";

export interface LeaveSearchParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: "pending" | "approved" | "rejected";
  staffId?: string;
  leaveTypeId?: string;
  dateFrom?: string;
  dateTo?: string;
}


export const createLeave = async (payload: LeaveCreate): Promise<LeaveCreateApiResponse> => {
  const response = await axios.post<LeaveCreateApiResponse>("/leaves", payload);
  return response.data;
};


export const getAllLeaves = async (
  filters: LeaveSearchParams = {}
): Promise<LeaveListApiResponse> => {
  const response = await axios.get<LeaveListApiResponse>("/leaves", {
    params: { ...filters },
  });
  return response.data;
};

export const getMyLeaves = async (
  filters: LeaveSearchParams = {}
): Promise<LeaveListApiResponse> => {
  const response = await axios.get<LeaveListApiResponse>("/leaves/my", {
    params: { ...filters },
  });
  return response.data;
};


export const getLeaveById = async (leaveId: string): Promise<LeaveApiResponse> => {
  const response = await axios.get<LeaveApiResponse>(`/leaves/${leaveId}`);
  return response.data;
};


export const updateLeave = async (
  leaveId: string,
  payload: LeaveUpdate
): Promise<LeaveUpdateApiResponse> => {
  const response = await axios.put<LeaveUpdateApiResponse>(`/leaves/${leaveId}`, payload);
  return response.data;
};


export const deleteLeave = async (leaveId: string): Promise<LeaveApiResponse> => {
  const response = await axios.delete<LeaveApiResponse>(`/leaves/${leaveId}`);
  return response.data;
};


export const getLeaveByStaffId = async (staffId: string , filters: LeaveSearchParams = {}): Promise<LeaveListApiResponse> => {
  const response = await axios.get<LeaveListApiResponse>(`/leaves/staff/${staffId}` , { params: { ...filters } });
  return response.data;
};